// Asks for the stored identifier to be removed; an empty cell leaves it alone. Every language's word
// is accepted, since a sheet is not tied to the realm it is uploaded in.
const CLEAR_SENTINELS: ReadonlySet<string> = new Set(['clear', 'rensa', 'löschen', 'poista', 'tøm', 'effacer']);

export const isClearSentinel = (value: unknown, translations?: { clear: string }): boolean => {
  if (typeof value !== 'string') return false;
  const word = value.trim().toLowerCase();
  if (!word) return false;
  return CLEAR_SENTINELS.has(word) || word === translations?.clear.trim().toLowerCase();
};
